/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plural: NonNullable<unknown> }} Network_Online_Vehicle_CountInputs */

const fr_network_online_vehicle_count = /** @type {(inputs: Network_Online_Vehicle_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} véhicule${i?.plural} en ligne`)
};

const en_network_online_vehicle_count = /** @type {(inputs: Network_Online_Vehicle_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} vehicle${i?.plural} online`)
};

/**
* | output |
* | --- |
* | "{count} vehicle{plural} online" |
*
* @param {Network_Online_Vehicle_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_online_vehicle_count = /** @type {((inputs: Network_Online_Vehicle_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Online_Vehicle_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_online_vehicle_count(inputs)
	return en_network_online_vehicle_count(inputs)
});